import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, ArrowRight } from 'lucide-react';
import { useCurrency } from '../context/CurrencyContext';

const B2BBanner = () => {
  const { t, selectedCountry } = useCurrency();
  const basePath = `/${selectedCountry.code.toLowerCase()}`;
  
  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-amber-500 via-orange-500 to-red-500 py-2.5 px-4 shadow-[0_2px_10px_-2px_rgba(0,0,0,0.25)]">
      <div className="max-w-7xl mx-auto">
        <Link 
          to={`${basePath}/business`}
          data-testid="b2b-banner-link"
          className="flex items-center justify-center gap-2 sm:gap-3 text-white hover:text-amber-100 transition-colors group"
        >
          <div className="flex items-center gap-2">
            <Building2 className="h-4 w-4 text-white" />
            <span className="text-xs sm:text-sm font-bold text-white">
              {t('b2bBanner.text')}
            </span>
          </div>
          <span className="text-xs sm:text-sm text-amber-100 group-hover:text-white flex items-center gap-1 font-semibold">
            <span className="hidden xs:inline">{t('b2bBanner.cta')}</span>
            <ArrowRight className="h-3 w-3 sm:h-4 sm:w-4 group-hover:translate-x-1 transition-transform" />
          </span>
        </Link>
      </div>
    </div>
  );
};

export default B2BBanner;
